import {
  captureException,
  dedupeIntegration,
  eventFiltersIntegration,
  httpContextIntegration,
  init,
  linkedErrorsIntegration,
} from '@sentry/browser';

const dsn = process.env.SENTRY_FRONTEND_DSN;

if (dsn) {
  init({
    dsn,
    environment: process.env.SENTRY_FRONTEND_ENVIRONMENT,
    release: process.env.APP_REVISION,
    dataCollection: {
      userInfo: false,
      cookies: false,
      httpHeaders: false,
      httpBodies: [],
      urlQueryParams: false,
    },
    defaultIntegrations: false,
    integrations: [eventFiltersIntegration(), dedupeIntegration(), linkedErrorsIntegration(), httpContextIntegration()],
    initialScope: { tags: { namespace: 'infakt-app-frontend' } },
    ignoreErrors: [
      /ResizeObserver loop limit exceeded/,
      /Non-Error promise rejection captured/,
      /ChunkLoadError/,
      /Loading chunk/,
      /Network Error/,
      /NetworkError/,
      /Script error/,
      /Non-Error exception captured/,
      /extension\//,
      /^moz-extension:\/\//,
      /^chrome-extension:\/\//,
    ],
  });
}

export const trackError = (
  error: Error,
  tags?: Record<string, string | number | boolean>,
  metadata?: Record<string, unknown>,
) => {
  captureException(error, { tags, extra: metadata });
};
